import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full pt-16">
      <div className="relative h-[420px] md:h-[520px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dramatic%20background%20with%20swirling%20warm%20orange%20and%20deep%20red%20gradients%2C%20artistic%20motion%20blur%2C%20modern%20editorial%20design%2C%20bold%20dynamic%20composition%2C%20dark%20moody%20atmosphere%20with%20warm%20accents%2C%20no%20people%2C%20abstract%20expressionism%20style&width=1600&height=900&seq=hero-bg-chigua51&orientation=landscape"
          alt="吃瓜51"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center px-4 w-full max-w-3xl">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-3 md:mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              最新<span className="text-primary-400">吃瓜</span>爆料，一站掌握
            </h1>
            <p className="text-sm md:text-lg text-white/80 mb-6 md:mb-8 max-w-xl mx-auto leading-relaxed">
              第一时间汇聚娱乐八卦、明星内幕、社会热点，让你随时随地吃瓜不断线，做最快的吃瓜群众
            </p>
            <div className="flex items-center justify-center gap-3 flex-wrap">
              <Link
                to="/category/yule-bagua"
                className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-compass-3-line"></i>
                开始吃瓜
              </Link>
              <Link
                to="/category/dujia-baoliao"
                className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/20 text-white text-sm font-medium hover:bg-white/30 transition-colors backdrop-blur-sm whitespace-nowrap"
              >
                <i className="ri-spy-line"></i>
                独家爆料
              </Link>
            </div>
            <div className="flex items-center justify-center gap-6 mt-8 text-white/60 text-xs">
              <span className="flex items-center gap-1">
                <i className="ri-article-line"></i>
                每日更新 50+ 条爆料
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-user-smile-line"></i>
                百万吃瓜群众在线
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-fire-line"></i>
                24小时热点追踪
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}